export enum CardBrand {
  DinersClub = 'Diners Club',
  Mastercard = 'Mastercard',
  UnionPay = 'UnionPay',
  Visa = 'Visa',
  AmericanExpress = 'American Express',
  Discover = 'Discover',
  JCB = 'JCB',
  EBT = 'EBT',
  TargetMastercard = 'Target Mastercard',
  Link = 'link',
  Klarna = 'klarna',
  CashApp = 'cashapp',
}

type BaseCard = { external_id: string } & Partial<{
  address_zip_check: string
  brand: CardBrand
  display_brand: CardBrand | string
  default_source: boolean
  exp_date: string
  funding: string
  is_ebt: boolean
  last_4_digits: string
  stripe_tokenization_method: string | null
  metadata?: Record<string, string | number>
}>

type CashApp = BaseCard & {
  brand: CardBrand.CashApp
  metadata: CashAppPaymentMethod['metadata']
}

type Klarna = BaseCard & {
  brand: CardBrand.Klarna
  metadata: KlarnaPaymentMethod['metadata']
}

export type PaymentMethod = BaseCard | CashApp | Klarna

export type CreditCardAddResponse = Omit<PaymentMethod, 'external_id'> & {
  id: number
  default: boolean
  address_zip: string
}

type StripeElementError = { message: string | undefined }
export type StripeState = {
  error: StripeElementError | undefined
  empty?: boolean
  complete?: boolean
}

export type AddCreditCardParams = {
  card: AddCreditCardPayload
}
type AddCreditCardPayload = {
  card_token: string
  default: boolean
  metadata: {
    card_holder_name: string
  }
}

type BasePaymentMethod = {
  id: string
  external_id: string
  is_reauth_eligible: boolean
  provisions: [
    {
      id?: string
      card: {
        token: {
          type: 'link' | 'apple_pay' | 'google_pay' | 'android_pay' | ''
        }
      }
    },
  ]
  last_used_at: string
  is_ebt: boolean
  is_ebt_validated: boolean
  default_source: boolean
}

type CardPaymentMethod = BasePaymentMethod & {
  type: 'card'
  card: {
    brand: CardBrand
    display_brand: string
    funding: string
    last_4_digits: string
    expiration_date: {
      month: number
      year: number
    }
    address: {
      zip: string
      zip_check: string
    }
  }
  metadata: null
}

type CashAppPaymentMethod = BasePaymentMethod & {
  type: CardBrand.CashApp
  metadata: {
    buyerid: string
    cashtag: string
  }
}

type KlarnaPaymentMethod = BasePaymentMethod & {
  type: CardBrand.Klarna
  metadata: {
    dob_day: number
    dob_month: number
    dob_year: number
  }
}

export type APIPaymentMethodsResponse = {
  data: {
    payment_methods: (CardPaymentMethod | CashAppPaymentMethod | KlarnaPaymentMethod)[]
  }
}

export type PaymentMethodsResponse = {
  paymentMethods: PaymentMethod[]
  defaultPaymentMethod: PaymentMethod | undefined
}

export type SetupIntentResponse = {
  data: {
    setup_intent: {
      client_secret: string
      payment_method: {
        id?: string
      }
      status: string
    }
  }
}
